/*eslint-disable*/
import Cookies from '../constants/Cookies';

export default function gtmInit() {
    let allowList = [];
    Cookies.forEach((cookiesGroup) => {
        cookiesGroup.cookies.forEach((cookie) => {
            if (document.cookie.indexOf(cookie.id) === -1 || !cookie.gtmKeys) {
                return;
            }
            allowList = allowList.concat(cookie.gtmKeys);
        });
    });

    if (allowList.length === 0) {
        return;
    }

    // Allow triggers access
    allowList = allowList.concat(['evl', 'cl', 'Trigger', 'hl', 'jel', 'lcl', 'sdl', 'tl', 'ytl']);
    // Allow variable access
    allowList = allowList.concat(['k', 'v', 'c', 'ctv', 'e', 'jsm', 'v', 'dbg', 'd', 'vis', 'gas', 'f', 'j', 'smm', 'r', 'remm', 'u']);

    window.dataLayer = [];
    window.dataLayer.push({'gtm.allowlist': allowList});

    (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),
            dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',env.GTM_KEY);
}